class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.cached = {};
    this.variantId = this.dataset.variantId;
    this.container = this.closest('.card-wrapper');
    
    if (this.variantId || theme.config.mqlSmall) {
      this.addEventListener('mouseenter', this.onHoverHandler.bind(this));
      this.querySelector('a').addEventListener('click', (event) => event.preventDefault());
    }
    else {
      this.addEventListener('mouseenter', this.onHoverHandler.bind(this));
    }
  }

  onHoverHandler() {
    if (this.variantId) {
      (theme.config.mqlSmall || theme.config.isTouch) ? this.colorSwatchChange() : this.colorSwatchFetch();
    }
    else {
      this.colorSwatchChange();
    }
  }

  colorSwatchChange(forceUpdate) {
    const image = this.container.querySelector('.card--image-animate.media img');
    const pictureSource = this.container.querySelector('.card--image-animate.media source');

    if (image !== null || pictureSource != null || forceUpdate) {
      if (image !== null) {
        image.src = this.dataset.src;
        image.srcset = this.dataset.srcset;
      }

      if (pictureSource !== null) {
        pictureSource.srcset = this.dataset.srcset;
      }

      const swatches = this.container.querySelectorAll('.color-swatch');
      swatches.forEach((swatch) => {
        swatch.classList.remove('is-active');
      });
  
      this.classList.add('is-active');

      // Revert div to a href for wrapper
      this.container.querySelector('.card--image-animate.media').style.display = "block";
      if(this.container.querySelector('.card-media-video')) this.container.querySelector('.card-media-video').style.display = "none";
    }
  }

  colorSwatchFetch() {
    const productHandle = this.dataset.productHandle;
    const collectionHandle = this.dataset.collectionHandle;
    let sectionUrl = `${theme.routes.root_url}/products/${productHandle}?variant=${this.variantId}&view=card`;

    if (collectionHandle.length > 0) {
      sectionUrl = `${theme.routes.root_url}/collections/${collectionHandle}/products/${productHandle}?variant=${this.variantId}&view=card`;
    }

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    if (this.cached[sectionUrl]) {
      this.renderProductInfo(this.cached[sectionUrl]);
      return;
    }

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.cached[sectionUrl] = html;
        this.renderProductInfo(html);
      })
      .catch(e => {
        console.error(e);
      });
  }

  renderProductInfo(html) {
    this.updateButtons(html);
    this.updateTitle(html);
    this.updatePrice(html);

    this.colorSwatchChange(true);
  }

  updateTitle(html) {
    const selector = '.card-information__text';
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);

    if (source && destination) destination.innerHTML = source.innerHTML + '<small>&ndash;&nbsp;' + this.getAttribute('title') + '</small>';
  }

  updatePrice(html) {
    if (html.querySelector('color-swatch-radios')) return;
    
    const selector = '.price';
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateButtons(html) {
    const selector = '.card-information__button';
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);

    if (source && destination) destination.innerHTML = source.innerHTML;

    destination.classList.remove('is-expanded');
    if (source.classList.contains('is-expanded')) destination.classList.add('is-expanded');
  }
}
customElements.define('color-swatch', ColorSwatch);

class ColorSwatchRadios extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      soldOut: 'price--sold-out',
      onSale: 'price--on-sale',
      noCompare: 'price--no-compare',
      hidden: 'hidden',
      loading: 'loading'
    };
    this.selectors = {
      cardWrapper: '.card-wrapper',
      priceWrapper: '.price',
      price: '.price__regular .price-item--regular',
      comparePrice: '.price__sale .price-item--regular',
      salePrice: '.price__sale .price-item--sale',
      unitWrapper: '.unit-price',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-base]'
    };

    this.miniCart = document.querySelector('mini-cart');

    this.init();
    this.addEventListener('change', this.onVariantChange);

    const buttons = this.querySelectorAll('.swatch:not(.disabled)');
    buttons.forEach((button) => button.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    buttons.forEach((button) => button.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));

    const inputs = this.querySelectorAll('.swatch:not(.disabled) input');
    inputs.forEach((input) => input.addEventListener('click', this.onClickHandler.bind(this)));
  }

  cacheElements() {
    this.container = this.closest(this.selectors.cardWrapper);
    this.cache = {
      priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
      price: this.container.querySelector(this.selectors.price),
      comparePrice: this.container.querySelector(this.selectors.comparePrice),
      salePrice: this.container.querySelector(this.selectors.salePrice),
      priceHTML: this.container.querySelector(this.selectors.priceWrapper).cloneNode(true).innerHTML,
      priceClass: this.container.querySelector(this.selectors.priceWrapper).cloneNode(true).getAttribute('class'),
    };
  }

  onClickHandler(event) {
    const input = event.currentTarget;
    const button = input.parentNode;
    const variantId = this.currentVariant.id;

    if (variantId) {
      if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
        Shopify.postLink(theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1
          },
        });
        return;
      }

      input.setAttribute('disabled', '');
      button.classList.add(this.classes.loading);
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.miniCart && this.miniCart.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          input.removeAttribute('disabled');
          button.classList.remove(this.classes.loading);
        });
    }
  }

  onEnterHandler(event) {
    const target = event.currentTarget;
    const input = target.querySelector('input');
    input.checked = true;
    this.dispatchEvent(new Event('change'));

    setTimeout(() => {
      this.cacheElements();
      this.updatePrice();
      this.updateUnitPrice();
    });
  }

  onLeaveHandler() {
    this.cache.priceWrapper.innerHTML = this.cache.priceHTML;
    this.cache.priceWrapper.setAttribute('class', this.cache.priceClass);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  }

  init() {
    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
  }

  updatePrice() {
    const variant = this.currentVariant;
  
    if (variant) {
      // Remove classes
      this.cache.priceWrapper.classList.remove(this.classes.soldOut);
      this.cache.priceWrapper.classList.remove(this.classes.onSale);
      this.cache.priceWrapper.classList.remove(this.classes.noCompare);

      if (variant.available == false) {
        this.cache.priceWrapper.classList.add(this.classes.soldOut);
      }
      else if (variant.compare_at_price > variant.price) {
        this.cache.priceWrapper.classList.add(this.classes.onSale);
      }

      // Regular price
      this.cache.price.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.price, theme.shopSettings.moneyFormat) + '</bdi></price-money>';

      // Sale price, if necessary
      if (variant.compare_at_price > variant.price) {
        this.cache.comparePrice.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.compare_at_price, theme.shopSettings.moneyFormat) + '</bdi></price-money>';
        this.cache.salePrice.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.price, theme.shopSettings.moneyFormat) + '</bdi></price-money>';
      }
      else {
        
      }
    }
  }

  updateUnitPrice() {
    const variant = this.currentVariant;
  
    if (this.container.querySelector(this.selectors.unitWrapper)) {
      if (variant && variant.unit_price) {
        this.container.querySelector(this.selectors.unitPrice).innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.unit_price, theme.shopSettings.moneyFormat) + '</bdi></price-money>';
        this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
        this.container.querySelector(this.selectors.unitWrapper).classList.remove(this.classes.hidden);
      }
      else {
        this.container.querySelector(this.selectors.unitWrapper).classList.add(this.classes.hidden);
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setAvailability() {
    if (!this.currentVariant) return;

    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.currentVariant.options.map((value,index) => {return {value, index: `option${index+1}`}})
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
    const input = group.querySelector('input[data-option-value="'+ value +'"]');

    if (!input) return;

    // Variant exists - enable & show variant
    input.removeAttribute('disabled');
    input.parentNode.classList.remove('disabled');

    // Variant sold out - cross out option (remains selectable)
    if (obj.soldOut) {
      input.setAttribute('disabled', '');
      input.parentNode.classList.add('disabled');
    }
  }

  disableVariantGroup(group) {
    group.querySelectorAll('input').forEach((input) => {
      input.setAttribute('disabled', '');
      input.parentNode.classList.add('disabled');
    });
  }

  manageOptionState(option, values) {
    const group = this.querySelector('.variant-input-wrapper[data-option-index="'+ option +'"]');

    // Loop through each option value
    values.forEach(obj => {
      this.enableVariantOption(group, obj);
    });
  }

  createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce((options, variant) => {

      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(index => {

        if (variant[index] === null) return;

        let entry = options[index].find(option => option.value === variant[index]);

        if (typeof entry === 'undefined') {
          // If option has yet to be added to the options tree, add it
          entry = {value: variant[index], soldOut: true}
          options[index].push(entry);
        }

        const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
        const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')

        switch (index) {
          case 'option1':
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            break;
          case 'option2':
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant['option1'] === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          case 'option3':
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (
              currentOption1 && variant['option1'] === currentOption1.value
              && currentOption2 && variant['option2'] === currentOption2.value
            ) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
        }
      })

      return options;
    }, { option1: [], option2: [], option3: []})
  }
}
customElements.define('color-swatch-radios', ColorSwatchRadios);




document.addEventListener('DOMContentLoaded', () => {
  // --- 1. 各種対象テキストの定義 ---
  
  // ① 画面幅に関係なく「常に改行を追加」する文字
  const alwaysBrChars = ['"心とからだ"の健康は', '素材に命を加える、','素材の旨みを凝縮する、', '忙しい朝の味方。', 'お電話も承ります。', '幅が劇的に広がり、', 'ウォーターシールで'];
  
  // ② 画面幅に関係なく「常にspanで囲む」文字
  const spanChars = ['高熱伝導で素早く火を通します。', '特定の文字B', '特定の文字C'];
  
  // ③ 1080px以下の時だけ「改行を追加」する文字
  const media1080BrChars = ['独自の5層構造で'];

  // ④ 499px以下の時だけ「改行を追加」する文字
  const media499BrChars = ['独自のステンレス', '毎日の料理をワンランクアップさせる、', '調理の腕がワンランク上がる', '高火力でゆとりを', '至福の「煮る・茹でる」'];

  // ★変更点：ページ内の見出しと .banner__subheading を一括取得
  const targetElements = document.querySelectorAll('h1, h2, h3, h4, .banner__subheading');
  
  // メディアクエリの定義（1080px用と499px用）
  const mq1080 = window.matchMedia('(max-width: 1080px)');
  const mq499 = window.matchMedia('(max-width: 499px)');
  
  // 初期HTML（常時適用処理後）を保存するマップ
  const baseHtmlMap = new Map();

  // --- 2. 常に適用する処理 ＆ ベースHTMLの保存 ---
  targetElements.forEach((el, index) => {
    let currentHtml = el.innerHTML;
    let needsUpdate = false;

    // ① 常に改行を追加
    for (const char of alwaysBrChars) {
      if (currentHtml.includes(char)) {
        currentHtml = currentHtml.split(char).join(`${char}<br>`);
        needsUpdate = true;
      }
    }

    // ② 常にspanで囲む
    for (const char of spanChars) {
      if (currentHtml.includes(char)) {
        currentHtml = currentHtml.split(char).join(`<span class="highlight">${char}</span>`);
        needsUpdate = true;
      }
    }

    // 変更があればDOMを書き換える
    if (needsUpdate) {
      el.innerHTML = currentHtml;
    }

    // ★重要: レスポンシブ処理で「元に戻す」ための基準として、この状態のHTMLを保存しておく
    baseHtmlMap.set(index, currentHtml);
  });

  // --- 3. 画面幅に応じて適用する処理 ---
  const handleResize = () => {
    targetElements.forEach((el, index) => {
      let currentHtml = baseHtmlMap.get(index); // 必ずベースHTMLからスタート
      let needsUpdate = false;

      // --- 1080px以下の時（レスポンシブ用の改行を追加） ---
      if (mq1080.matches) {
        for (const char of media1080BrChars) {
          if (currentHtml.includes(char)) {
            currentHtml = currentHtml.split(char).join(`${char}<br>`);
            needsUpdate = true;
          }
        }
      }

      // --- 499px以下の時（1080px用の改行に上乗せして追加） ---
      if (mq499.matches) {
        for (const char of media499BrChars) {
          if (currentHtml.includes(char)) {
            currentHtml = currentHtml.split(char).join(`${char}<br>`);
            needsUpdate = true;
          }
        }
      }

      // どちらかの画面幅条件に合致して変更があればDOMを更新、なければベースHTMLに戻す
      if (needsUpdate) {
        el.innerHTML = currentHtml;
      } else {
        // 常時適用の処理（改行やspan）だけが反映された状態に戻す
        el.innerHTML = baseHtmlMap.get(index);
      }
    });
  };

  // 初回実行
  handleResize();

  // リサイズ時のイベントリスナー登録（各ブレイクポイントをまたいだ瞬間だけ発火）
  mq1080.addEventListener('change', handleResize);
  mq499.addEventListener('change', handleResize);
});




// 備忘録：どこに追記したか分かるようにコンソールへ出力
console.log('color-swatches.jsに追記');

document.addEventListener("DOMContentLoaded", function() {
  // 1. スマホ端末からのアクセスかどうかを判定（iPhone、またはAndroidのスマホ）
  const isMobile = /iPhone|Android.+Mobile/.test(navigator.userAgent);

  // スマホからのアクセスの場合のみ実行
  if (isMobile) {
    // 2. クラス名で対象の要素を取得
    const targetElements = document.querySelectorAll('.banner__heading'); 

    targetElements.forEach(function(element) {
      // 3. 要素の中に「093-201-1210」が含まれているか確認
      if (element.textContent.includes('093-201-1210')) {
        // 4. h3タグそのものをaタグに置き換える（閉じタグは </a> に修正しています）
        element.outerHTML = '<a class="banner__heading h1 tel-link" href="tel:093-201-1210">093-201-1210</a>';
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const deleteStr = 'JPY';

  // TreeWalkerを使って、body要素内の「テキストノード（純粋な文字部分）」だけを抽出する
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT, // テキストのみを対象にするフィルタ
    null,
    false
  );

  let node;
  // ページ内のすべてのテキストを1つずつループ処理
  while ((node = walker.nextNode())) {
    // scriptタグやstyleタグの中身は誤作動を防ぐため除外
    if (node.parentNode.nodeName === 'SCRIPT' || node.parentNode.nodeName === 'STYLE') {
      continue;
    }

    // テキストの中に「JPY」が含まれているかチェック
    if (node.nodeValue.includes(deleteStr)) {
      // 「JPY」を空文字('')に置換
      node.nodeValue = node.nodeValue.split(deleteStr).join('');
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.list-social__link').forEach(function (target) {
    if (!target.querySelector('.instagram-check-text')) {
      const span = document.createElement('span');
      span.className = 'instagram-check-text';
      span.textContent = 'instagramもチェック！';

      target.appendChild(span);
    }
  });
});